import axios from "@/axios";

export function SendingImageCancel() {
  return axios.delete<Array<string>>("/products/send-media-to-cafe");
}
